export const reduxKey = '@@StatusUpdate';
export const MAXIMUM_SHORT_STATUS_LENGTH = 110;
export const MAXIMUM_LONG_STATUS_LENGTH = 600;
export const MAXIMUM_STATUS_LENGTH = 640000;
export const MINIMUM_STATUS_LENGTH = 1; // requirement
export const NUMBER_OF_TIMES_TO_SHOW_TUTORIAL_SUBTITLE = 5;

//# sourceMappingURL=constants.js.map